"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirectDebitSummary = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../shared/core");
var data_1 = require("../../data");
var DirectDebitSummaryUI_1 = require("./ui/DirectDebitSummaryUI");
var components_1 = require("./ui/components");
exports.DirectDebitSummary = (0, core_1.withCustomerAndAccountIds)(function (_a) {
    var accountId = _a.accountId;
    var _b = (0, data_1.useDirectDebitSummary)(accountId), error = _b.error, loading = _b.loading, data = _b.data;
    if (loading) {
        return react_1.default.createElement(components_1.Loading, null);
    }
    if (error) {
        return react_1.default.createElement(components_1.Error, null);
    }
    if (data) {
        return (react_1.default.createElement(DirectDebitSummaryUI_1.DirectDebitSummaryUI, { directDebit: data.directDebit, recommendedDirectDebit: data.recommendedDirectDebit }));
    }
    return null;
});
